// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CouponSubmitDocumentsRequestModel {
    static getAttributeTypeMap() {
        return CouponSubmitDocumentsRequestModel.attributeTypeMap;
    }
}
CouponSubmitDocumentsRequestModel.discriminator = undefined;
CouponSubmitDocumentsRequestModel.additionalProperties = false;
CouponSubmitDocumentsRequestModel.attributeTypeMap = [
    {
        "name": "docType",
        "baseName": "docType",
        "type": "number"
    },
    {
        "name": "files",
        "baseName": "files",
        "type": "Array<RequestFile>"
    },
];
//# sourceMappingURL=couponSubmitDocumentsRequestModel.js.map